function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  cursor: pointer;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  // override default button styles\n  appearance: none;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { fontSize, position, top, right, left, display, fontWeight, space, color } from 'styled-system';
import { Link } from '@dutchie/common/components/rebass-compat';
import styled, { css } from 'styled-components';
export default function(props) {
    var as = props.as, otherProps = _object_without_properties(props, [
        "as"
    ]);
    if (as === 'button') {
        return /*#__PURE__*/ _jsx(StyledButton, _object_spread({}, otherProps));
    }
    return /*#__PURE__*/ _jsx(StyledLink, _object_spread({}, otherProps));
};
var styles = css(_templateObject(), function(param) {
    var theme = param.theme;
    var _theme_customized_colors, _theme_customized, _theme_colors;
    var _theme_customized_colors_buttonsLinks, _ref;
    return (_ref = (_theme_customized_colors_buttonsLinks = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_colors = _theme_customized.colors) === null || _theme_customized_colors === void 0 ? void 0 : _theme_customized_colors.buttonsLinks) !== null && _theme_customized_colors_buttonsLinks !== void 0 ? _theme_customized_colors_buttonsLinks : theme === null || theme === void 0 ? void 0 : (_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.linkColor) !== null && _ref !== void 0 ? _ref : '#4597e0';
}, fontSize, fontWeight, position, top, right, left, display, space, color);
var StyledLink = styled(Link)(_templateObject1(), styles);
var StyledButton = styled.button(_templateObject2(), styles);
